import { render } from "./PasswordResetConfirm.vue?vue&type=template&id=7578fea0&scoped=true"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"

import "./PasswordResetConfirm.vue?vue&type=style&index=0&id=7578fea0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7578fea0"]])

export default __exports__